module.exports = __webpack_public_path__ + "static/media/cell-tower.5100ed60.png";